var render = function (_h,_vm) {var _c=_vm._c;return _c('GameScreen',_vm._g(_vm._b({key:_vm.data.key,staticClass:"is-type-interrupt"},'GameScreen',_vm.props,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }